{
  "page": { "title": "ผลต่างสต๊อก", "subtitle": "ตรวจสอบ {{count}} SKU" },
  "column": {
    "sku": "SKU",
    "expect": "คาดหวัง",
    "real": "จริง",
    "diff": "ผลต่าง",
    "pct": "%",
    "trend": "แนวโน้ม 30 วัน",
    "created": "เวลาบันทึก"
  },
  "tooltip": {
    "expect": "จำนวนที่คลังนับได้ในรายงานล่าสุด",
    "real": "จำนวนที่บันทึกไว้ใน Atlas ณ เวลาที่รายงานนั้นเข้ามา",
    "snapshot": "เวลาที่รายงานการนับสต๊อกของ SKU นี้เข้ามา ไม่ใช่เวลาที่งาน 06:00 น. ทำงาน"
  },
  "kpi": {
    "skus_checked": "SKU ที่ตรวจ",
    "over_threshold": "เกินเกณฑ์",
    "threshold": "เกณฑ์",
    "threshold_value": "{{pct}} % / {{pcs}} ชิ้น",
    "alert": "แจ้งเตือน Telegram"
  },
  "freshness": {
    "source_request": "แหล่งข้อมูล: {{source}} {{time}} (คำขอ {{id}})"
  },
  "alert": { "sent": "⚠ แจ้งเตือน", "none": "—" },
  "state": {
    "empty": "ไม่มีข้อมูลการกระทบยอด",
    "error": "ไม่สามารถโหลดรายงานผลต่างสต๊อกได้",
    "none": "—",
    "growing": "เพิ่มขึ้น"
  },
  "toolbar": {
    "search_placeholder": "ค้นหา SKU…",
    "export": "ส่งออก",
    "over_only": "เฉพาะที่เกินเกณฑ์"
  },
  "drawer": {
    "title": "{{sku}} — ประวัติรายงาน",
    "subtitle": "การนับสต๊อก {{count}} ครั้งล่าสุด เรียงจากใหม่ไปเก่า",
    "reported_at": "เวลารายงาน",
    "empty": "ยังไม่มีการนับสต๊อกสำหรับ SKU นี้",
    "error": "ไม่สามารถโหลดประวัติรายงานของ SKU นี้ได้"
  }
}
